var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more"},[_c('div',{staticClass:"content"},[_c('MoreForm',{attrs:{"list":_vm.allExcelData}})],1),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"buttom",on:{"click":_vm.exportExcel}},[_vm._v("导出")])])])}
var staticRenderFns = []

export { render, staticRenderFns }